import { Switch } from "@headlessui/react";
import classNames from "classnames";
import React from "react";

interface SwitchProps {
  checked: boolean;
  disabled?: boolean;
  onChange?: (status?: boolean) => void;
  className?: string;
}

export const SwitchInput: React.FC<SwitchProps> = ({
  checked,
  disabled,
  onChange = () => {},
  className = "",
}) => {
  return (
    <Switch
      checked={checked}
      onChange={() => {
        onChange(checked);
      }}
      disabled={disabled}
      className={classNames(
        `group inline-flex h-6 w-10 items-center rounded-full border border-grey-800 bg-transparent transition data-[checked]:bg-primary ${className}`,
        {
          "cursor-not-allowed": disabled,
          "!border-transparent !bg-disabled-grey": disabled && checked,
        },
      )}
    >
      <span className="size-[18px] translate-x-[3px] rounded-full bg-grey-800 transition group-data-[checked]:translate-x-[19px] group-data-[checked]:bg-white" />
    </Switch>
  );
};
